// Components==============
import BigToggle from 'components/UI/BigToggle/BigToggle';
import Modal from 'components/UI/Modal/Modal';
import Search from 'components/UI/Search/Search';
import { useRootModal } from 'hooks/useRootModal';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { createContext, useContext, useState } from 'react';
import { ProcessContext } from '../ProjectProcess/components/Process/Process';
import { ProjectProcessContext } from '../ProjectProcess/ProjectProcess';
import './AddActivityModal.module.scss';
import Courses from './components/Courses/Courses';
import Process from './components/Process/Process';
// =========================

type AddActivityModalContextType = {
  searchValue: string;
  handleClose: () => void;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  usedActivities?: (number | undefined)[];
  usedPhases?: (number | undefined)[];
  usedCourses?: (number | undefined)[];
  fn: 'switch' | 'add';
  permission?: ProcessType;
  origin: 'project' | 'growth';
  handleAddSwitch: (
    type: ProcessType,
    course: TrainingEntity | ActivityEntity | PhaseEntity
  ) => void;
};

export const AddActivityModalContext = createContext(
  {} as AddActivityModalContextType
);

export default function AddActivityModal({
  setModalIsOpen,
  fn,
  permission,
  origin,
  handleAddToDream,
  usedForDream,
  onbekend,
  setNeedsSaving,
}: {
  setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  permission?: ProcessType;
  fn: 'switch' | 'add';
  origin: 'project' | 'growth';
  handleAddToDream?: (id: number, type: ProcessType) => void;
  usedForDream?: {
    id: number;
    type: ProcessType;
  }[];
  onbekend?: boolean;
  setNeedsSaving?: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [searchValue, setSearchValue] = useState('');

  const { closeModal } = useRootModal();
  const { processGroups } = useContext(ProjectProcessContext);

  const { phaseIndex, processIndex } = useContext(ProcessContext);

  // const [saveDone, setSaveDone] = useState(false);

  const {
    handleAddProcessItem,
    handleSwitchProcessItem,
    isEditable,
  } = useContext(ProjectDetailsContext);

  const [selected, setSelected] = useState<
    'project.terms.activities' | 'general.terms.courses'
  >('project.terms.activities');

  const usedItems = processGroups?.map((group) => group.activities).flat();

  const usedPhases = usedItems
    ?.filter((item) => item?.process_type === 'App\\Phase')
    .map((activity) => activity?.id);

  const usedActivities = usedForDream
    ? usedForDream
        .filter((item) => item.type === 'App\\Activity')
        .map((activity) => activity.id)
    : usedItems
        ?.filter((item) => item?.process_type === 'App\\Activity')
        .map((activity) => activity?.id);

  const usedCourses = usedForDream
    ? usedForDream
        .filter((item) => item.type === 'App\\Training')
        .map((course) => course.id)
    : usedItems
        ?.filter((item) => item?.process_type === 'App\\Training')
        .map((course) => course?.id);

  function handleClose() {
    if (setModalIsOpen) return setModalIsOpen(false);
    closeModal();
  }

  function handleAddSwitch(
    type: ProcessType,
    item: TrainingEntity | ActivityEntity | PhaseEntity
  ) {
    if (origin === 'project') {
      if (fn === 'add')
        handleAddProcessItem(type, item, phaseIndex, processIndex);
      if (fn === 'switch') {
        handleSwitchProcessItem(type, item, phaseIndex, processIndex, onbekend);
        // Activates saving in token script
        if (onbekend && !isEditable) {
          setNeedsSaving(true);
        }
      }

      return handleClose();
    }

    if (origin === 'growth' && handleAddToDream) {
      handleAddToDream(item.id, type);
      return handleClose();
    }
  }

  return (
    <AddActivityModalContext.Provider
      value={{
        searchValue,
        setSearchValue,
        fn,
        permission,
        usedActivities,
        usedPhases,
        usedCourses,
        handleClose,
        origin,
        handleAddSwitch,
      }}
    >
      <Modal setModalIsOpen={setModalIsOpen}>
        <div styleName="wrapper">
          <div styleName="top">
            {/* {permission !== 'App\\Phase' && (
              <BigToggle
                selected={selected}
                setSelected={setSelected}
                values={['project.terms.activities', 'general.terms.courses']}
              />
            )} */}
            <Search value={searchValue} setValue={setSearchValue} />
          </div>
          {selected === 'project.terms.activities' ? <Process /> : <Courses />}
        </div>
      </Modal>
    </AddActivityModalContext.Provider>
  );
}
